import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { ValueSet } from '../value-set';
import { Comparison, MyUtility } from '../comparison';
import { AlertService } from '../alert.service';

@Component({
  selector: 'app-breakpoints',
  templateUrl: './breakpoints.component.html',
  styleUrls: ['./breakpoints.component.css']
})
export class BreakpointsComponent implements OnInit {

  public _testMethod;
  public drug: ValueSet;
  private _susceptible;
  private _intermediate;
  public resistant;

  private values: MicValueSet;

  constructor(private api: ApiService, private alerter: AlertService) {
    this.values = new NullValueSet();
  }

  ngOnInit() {
    this.drug = new ValueSet(this.drugs, "id", null);
  }

  get testMethod() {
    return this._testMethod;
  }
  set testMethod(value) {
    this._testMethod = value;

    if (!value)
      this.values = new NullValueSet();
    else if (value.id == 1)
      this.values = new MicValueSet();
    else
      this.values = new DiskValueSet();

    console.log('this.values', this.values);
  }

  compare(a, b) {
    return Comparison.equals(a, b);
  }

  public get susceptible() {
    return this._susceptible;
  }
  public set susceptible(value) {
    this._susceptible = value;
    this.values.susceptibleWasSet(this);
  }

  public get intermediate() {
    return this._intermediate;
  }
  public set intermediate(value) {
    this._intermediate = value;
    this.values.intermediateWasSet(this);
  }

  validationErrors = [];

  get multiDrugResistantIsolatesOnly() {
    return this.api.session.currentCriteria.breakpoints.multiDrugResistantIsolatesOnly;
  }
  set multiDrugResistantIsolatesOnly(value) {
    console.log("multiDrugResistantIsolatesOnly -> " + value);
    this.api.session.currentCriteria.breakpoints.multiDrugResistantIsolatesOnly = value;
  }

  get selectedType() {
    return this.api.session.currentCriteria.breakpoints.breakpointType;
  }
  set selectedType(value) {
    this.api.session.currentCriteria.breakpoints.breakpointType = value;
  }

  get breakpointTypes() {
    return this.api.session.breakpointTypes;
  }

  get testMethods() {
    return [{ id: 2, name: "Disk Diffusion" }, { id: 1, name: "MIC" }];
  }

  get drugs() {
    return this.api.session.drugs.find(x => x.name === "All").children;
  }

  get adjustments() {
    return this.api.session.currentCriteria.breakpoints.adjustments;
  }

  get breakpoints() {
    return this.api.session.currentCriteria.breakpoints;
  }

  addAdjustment() {
    let errors = this.values.getValidationErrors(this);
    if (errors.length > 0) {
      this.alerter.alert("Please correct the following issues before proceeding:\n" + errors.map(x => "  • " + x).join("\n"));
      return;
    }

    let newAdjustment = {
      testMethod: this.testMethod,
      drug: this.drug.objectValue,
      susceptible: this.susceptible,
      intermediate: this.intermediate,
      resistant: this.resistant,
      sirDisplayText: this.susceptible + " / " + this.getSIRText(this.intermediate) + " / " + this.getSIRText(this.resistant)
    };
    console.log("new adjustment", newAdjustment);

    this.values.cleanup(newAdjustment);

    console.log("new adjustment (post cleanup)", newAdjustment);

    this.adjustments.push(newAdjustment);
  }

  getSIRText(val) {
    if (MyUtility.isNothing(val)) {
      return "-";
    }

    return val;
  }

  deleteAdjustment(adjustment) {
    let index = this.adjustments.indexOf(adjustment);
    this.adjustments.splice(index, 1);
  }

  deleteAllAdjustments() {
    this.api.session.currentCriteria.breakpoints.adjustments = [];
  }

  reset() {
    this.testMethod.selectedIdValue = null;
    this.drug.selectedIdValue = null;
    this.susceptible = null;
    this.intermediate = null;
    this.resistant = null;
  }

  validate() {
    this.validationErrors = this.values.getValidationErrors(this);
  }
}

export class MicValueSet {
  values = [];
  intermediateMessage: string;
  constructor() {
    this.values = this.getValues();
    this.intermediateMessage = this.getMessage();
  }
  getValues() {
    return [.001, .002, .004, .008, .015, .03, .06, .12, .25, .5, 1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048];
  }
  parse(s): number {
    if (s == null || s.length < 1)
      return null;

    let f = parseFloat(s);
    let diffs = [];
    diffs = this.values.map(x => this.map(x, f)).sort(this.compare);
    console.log('diffs', diffs);

    return diffs[0].value;
  }

  susceptibleWasSet(component: BreakpointsComponent) {
    if (!this.isSet(component.susceptible))
      return;

    let val = this.parse(component.susceptible);
    component.intermediate = this.getNeighbor(val, 0).toString();
  }

  intermediateWasSet(component: BreakpointsComponent) {

    if (!this.isSet(component.intermediate))
      return;

    let val = this.parse(component.intermediate);
    component.resistant = this.getNeighbor(val, this.up).toString();
  }

  isSet(val) {
    return val && val.length > 0;
  }

  map(x, target) {
    let diff = Math.abs(target - x);
    if (target > x)
      diff = 1000000;
    return { value: x, diff: diff };
  }

  compare(left, right) {
    return left.diff - right.diff;
  }

  getNeighbor(value: number, offset: number): NullableNumber {
    let index = this.values.indexOf(value);
    if (index < 0)
      throw new Error("Value not found: " + value);

    index += offset;
    if (index < 0 || index >= this.values.length)
      return NullableNumber.null();

    return new NullableNumber(this.values[index]);
  }

  getMessage() {
    return "For a range of Intermediate values, enter the highest Intermediate value."
  }


  getValidationErrors(component: BreakpointsComponent): any {
    let validationErrors = [];


    let sus = NullableNumber.parse(component.susceptible);
    let int = NullableNumber.parse(component.intermediate);
    let res = NullableNumber.parse(component.resistant);

    console.log("sir (for validation):", { s: sus, i: int, r: res });

    if (!sus.hasValue) {
      validationErrors.push("You must provide at least a value for Susceptible");
    }

    if (int.hasValue && this.isLowerThan(int.value, sus)) {
      validationErrors.push(`The Intermediate value must be ${this.higher} than the Susceptible value`);
    }

    if (res.hasValue) {
      if (int.hasValue && this.isLowerThanOrEqual(res.value, int.value))
        validationErrors.push(`The Resistant value must be ${this.higher} than the Intermediate value`);
      else if (sus.hasValue && this.isLowerThanOrEqual(res.value, sus.value))
        validationErrors.push(`The Resistant value must be ${this.higher} than the Susceptible value`);

      if (int.hasValue) {
        let maxRes = this.getNeighbor(int.value, this.up);
        if (maxRes.hasValue && this.isHigherThan(res.value, maxRes.value))
          validationErrors.push(`Resistant value cannot be that far ${this.beyond} Intermediate`);
      }
      else if (sus.hasValue) {
        let maxRes = this.getNeighbor(sus.value, this.up);
        if (maxRes.hasValue && this.isHigherThan(res.value, maxRes.value))
          validationErrors.push(`Resistant value cannot be that far ${this.beyond} Susceptible`);
      }
    }

    return validationErrors;
  }

  cleanup(model) {
    console.log("cleanup", model);
    if (!model.intermediate)
      model.intermediate = model.susceptible;

    if (!model.resistant)
      model.resistant = this.getNeighbor(parseFloat(model.intermediate), this.up).value;
  }

  get up(): number {
    return 1;
  }

  get higher(): string {
    return "greater";
  }

  get beyond(): string {
    return "beyond";
  }

  isLowerThanOrEqual(n, target): boolean {
    return n <= target;
  }
  isLowerThan(n, target): boolean {
    return n < target;
  }

  isHigherThan(n, target): boolean {
    return n > target;
  }
}

export class DiskValueSet extends MicValueSet {

  getValues() {
    let retval = [];
    for (let i = 6; i <= 75; i++)
      retval.push(i);

    return retval;
  }

  getMessage() {
    return "For a range of Intermediate values, enter the lowest Intermediate value."
  }


  get up(): number {
    return -1;
  }

  get higher(): string {
    return "less";
  }

  get beyond(): string {
    return "below";
  }

  isLowerThanOrEqual(n, target): boolean {
    return n >= target;
  }
  isLowerThan(n, target): boolean {
    return n > target;
  }

  isHigherThan(n, target): boolean {
    return n < target;
  }
}

export class NullValueSet extends MicValueSet {
  getValues() {
    return [];
  }
  getMessage() {
    return "";
  }
  getValidationErrors() {
    return ["Invalid selection"];
  }
}

export class NullableNumber {
  value;

  constructor(value) {
    this.value = value;
  }

  toString(): string {
    if (!this.value)
      return "";
    return this.value.toString();
  }

  get hasValue() {
    return this.value != null;
  }

  public static null(): NullableNumber {
    return new NullableNumber(null);
  }

  public static parse(s) {
    if (s == null || s.length < 1)
      return this.null();

    return new NullableNumber(parseFloat(s));
  }
}
